/* ADD ANSWERS */
export const ADD_ANSWERS = "ADD_ANSWERS"
export const ADD_ANSWERS_SUCCESS = "ADD_ANSWERS_SUCCESS"
export const ADD_ANSWERS_CLEAN = "ADD_ANSWERS_CLEAN"
export const ADD_ANSWERS_ERROR = "ADD_ANSWERS_ERROR"
